/** Function to safely open external URL in a new tab */
const safelyOpenExternalURL = (
  url: string | URL | undefined,
  target: string | undefined = '_blank'
) => {
  window.open(url, target, 'noopener,noreferrer');
};

export default safelyOpenExternalURL;
